import { Divider, MenuItem, Typography } from "@mui/material";
import FormSelect from "../form-select/FormSelect";
import { FormFieldPropsBase } from "../form/Form";

import type { JSX } from "react";

export type FormGroupedSelectOption<T extends string | number = number> = {
    label: string;
    value: T;
};

export type FormGroupedSelectOptionGroup<T extends string | number = number> = {
    heading: string;
    options: Array<FormGroupedSelectOption<T>>;
};

export type FormGroupedSelectProps<T extends string | number = number> = {
    rules?: any;
    optionGroups: Array<FormGroupedSelectOptionGroup<T>>;
} & FormFieldPropsBase;

export default function FormGroupedSelect<T extends string | number = number>({
    name,
    label,
    rules,
    optionGroups
}: FormGroupedSelectProps<T>): JSX.Element {

    return (
        <FormSelect
            name={name}
            label={label}
            sx={{
                width: 1
            }}
            rules={rules}
        >
            {optionGroups.map((optionGroup, groupIndex) => [
                <Typography
                    variant="subtitle1"
                    key={`${groupIndex}`}
                    sx={{
                        color: "secondary.main",
                        marginLeft: 1,
                        fontWeight: "bold"
                    }}>
                    {optionGroup.heading}
                </Typography>,

                optionGroup.options.map((option, optionIndex) => (
                    <MenuItem
                        key={`${groupIndex}:${optionIndex}`}
                        value={option.value}
                        sx={{
                            marginLeft: 1
                        }}
                    >
                        {option.label}
                    </MenuItem>
                )),

                <Divider key={`${groupIndex}:divider`} orientation="horizontal" />
            ])}
        </FormSelect>
    );
}